import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './OperationsTabs.css';

const OPERATIONS_TAB_CONFIG = [
  {
    key: 'publicaciones',
    label: 'Publicaciones',
    section: 'publicaciones',
  },
  {
    key: 'reservas',
    label: 'Reservas',
    section: 'reservas',
  },
  {
    key: 'flotilla',
    label: 'Flotilla',
    section: 'unidades',
  },
  {
    key: 'mis-reservas',
    label: 'Mis reservas',
    section: 'reservas-cliente',
  },
  {
    key: 'solicitudes',
    label: 'Centro de solicitudes',
    section: 'solicitudes',
  },
  {
    key: 'calendario',
    label: 'Calendario',
    section: 'calendario',
  },
];

const OperationsTabs = () => {
  const location = useLocation();

  const tabs = useMemo(() => {
    const isDashboard = location.pathname === '/dashboard';
    const sectionParam = isDashboard ? new URLSearchParams(location.search).get('section') : '';
    return OPERATIONS_TAB_CONFIG.map(tab => {
      const href = `/dashboard?section=${tab.section}`;
      const isActive = isDashboard && sectionParam === tab.section;
      return { ...tab, href, isActive };
    });
  }, [location]);

  return (
    <nav className="operations-tabs" aria-label="Secciones operativas">
      <div className="operations-tabs__container">
        {tabs.map(tab => (
          <Link
            key={tab.key}
            to={tab.href}
            className={`operations-tabs__item${tab.isActive ? ' is-active' : ''}`}
            aria-current={tab.isActive ? 'page' : undefined}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default OperationsTabs;
